import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CNodata = _resolveComponent("CNodata")
  const _component_el_image_viewer = _resolveComponent("el-image-viewer")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", null, [
      (_ctx.modelValue)
        ? (_openBlock(), _createBlock("div", _hoisted_1, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.srcList, (item, i) => {
              return (_openBlock(), _createBlock("img", {
                key: i,
                src: item,
                width: _ctx.width,
                height: _ctx.height,
                onClick: ($event: any) => (_ctx.openImg(item)),
                class: "mr10 mb10 cursor"
              }, null, 8, ["src", "width", "height", "onClick"]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (_ctx.noImage && !_ctx.modelValue)
        ? (_openBlock(), _createBlock(_component_CNodata, {
            key: 1,
            txt: "未上传图片",
            style: { height: `${_ctx.height}px`, width: `${_ctx.width}px` }
          }, null, 8, ["style"]))
        : _createCommentVNode("", true)
    ]),
    (!_ctx.modelValue)
      ? (_openBlock(), _createBlock("span", {
          key: 0,
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clickImg && _ctx.clickImg(...args))),
          class: "cursor"
        }, [
          _renderSlot(_ctx.$slots, "default", { images: _ctx.images })
        ]))
      : _createCommentVNode("", true),
    (_ctx.isViewer)
      ? (_openBlock(), _createBlock(_component_el_image_viewer, {
          key: 1,
          "url-list": _ctx.currentImages,
          onClose: _ctx.handleViewerClose
        }, null, 8, ["url-list", "onClose"]))
      : _createCommentVNode("", true)
  ], 64))
}